import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['hint', 'strategy'];

  static values = { hints: Object };

  static classes = ['segmentActive', 'segmentIdle'];

  connect() {
    this.#renderHint();
  }

  pick({ params: { strategy } }) {
    this.strategyTarget.value = strategy;

    this.#renderHint();
    this.#renderSegments(strategy);
  }

  #renderSegments(strategy) {
    for (const segment of this.element.querySelectorAll('[data-webhook-form-strategy-param]')) {
      const active = segment.dataset.webhookFormStrategyParam === strategy;

      segment.setAttribute('aria-pressed', String(active));
      segment.classList.remove(...this.segmentActiveClasses, ...this.segmentIdleClasses);
      segment.classList.add(...(active ? this.segmentActiveClasses : this.segmentIdleClasses));
    }
  }

  #renderHint() {
    const strategy = this.strategyTarget.value;

    this.hintTarget.textContent = this.hintsValue[strategy] ?? '';
  }
}
